"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Severity = exports.Error = void 0;
var _runtime = require("@protobuf-ts/runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } // @generated by protobuf-ts 2.8.2 with parameter long_type_number,keep_enum_prefix,generate_dependencies
// @generated from protobuf file "errors/errors.proto" (package "errors", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf message errors.Error
 */
/**
 * @generated from protobuf enum errors.Severity
 */
var Severity; // @generated message type with reflection information, may provide speed optimized methods
(function (Severity) {
  Severity[Severity["SEVERITY_UNSPECIFIED"] = 0] = "SEVERITY_UNSPECIFIED";
  Severity[Severity["SEVERITY_ONE"] = 1] = "SEVERITY_ONE";
  Severity[Severity["SEVERITY_TWO"] = 2] = "SEVERITY_TWO";
  Severity[Severity["SEVERITY_THREE"] = 3] = "SEVERITY_THREE";
  Severity[Severity["SEVERITY_IGNORE"] = 4] = "SEVERITY_IGNORE";
})(Severity || (exports.Severity = Severity = {}));
var Error$Type = /*#__PURE__*/function (_MessageType) {
  function Error$Type() {
    _classCallCheck(this, Error$Type);
    return _callSuper(this, Error$Type, ["errors.Error", [{
      no: 1,
      name: "customer_facing_errors",
      kind: "scalar",
      repeat: 2 /*RepeatType.UNPACKED*/,
      T: 9 /*ScalarType.STRING*/
    }, {
      no: 2,
      name: "severity",
      kind: "enum",
      T: function T() {
        return ["errors.Severity", Severity];
      }
    }]]);
  }
  _inherits(Error$Type, _MessageType);
  return _createClass(Error$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        customerFacingErrors: [],
        severity: 0
      };
      globalThis.Object.defineProperty(message, _runtime.MESSAGE_TYPE, {
        enumerable: false,
        value: this
      });
      if (value !== undefined) (0, _runtime.reflectionMergePartial)(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
        end = reader.pos + length;
      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
          _reader$tag2 = _slicedToArray(_reader$tag, 2),
          fieldNo = _reader$tag2[0],
          wireType = _reader$tag2[1];
        switch (fieldNo) {
          case /* repeated string customer_facing_errors */1:
            message.customerFacingErrors.push(reader.string());
            break;
          case /* errors.Severity severity */2:
            message.severity = reader.int32();
            break;
          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? _runtime.UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }
      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* repeated string customer_facing_errors = 1; */
      for (var i = 0; i < message.customerFacingErrors.length; i++) writer.tag(1, _runtime.WireType.LengthDelimited).string(message.customerFacingErrors[i]);
      /* errors.Severity severity = 2; */
      if (message.severity !== 0) writer.tag(2, _runtime.WireType.Varint).int32(message.severity);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? _runtime.UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);
}(_runtime.MessageType);
/**
 * @generated MessageType for protobuf message errors.Error
 */
var Error = exports.Error = new Error$Type();